import { p as proxyCustomElement, H, h, c as Host } from './p-Dm99HnvB.js';
import { r as removeSSRSlot } from './p-DorpicPE.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.5.0
 */

const SidenavItem = /*@__PURE__*/ proxyCustomElement(class SidenavItem extends H {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Whether the sidenav item is selected.
         */
        this.selected = false;
        /**
         * Handles toggling the popover state.
         */
        this.handleClick = () => {
            const popover = this.el.closest("tds-popover-container[popover]");
            if (popover) {
                popover.togglePopover();
            }
        };
        /**
         * Handles the case where slotted content might change
         */
        this.handleSlottedContent = () => {
            const item = this.el.firstElementChild;
            if (this.selected) {
                item === null || item === void 0 ? void 0 : item.setAttribute("aria-current", "page");
            }
            else {
                item === null || item === void 0 ? void 0 : item.removeAttribute("aria-current");
            }
            item === null || item === void 0 ? void 0 : item.addEventListener("click", this.handleClick);
        };
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    connectedCallback() {
        this.handleSlottedContent();
    }
    componentWillLoad() {
        this.observer = new MutationObserver(this.handleSlottedContent);
        this.observer.observe(this.el, {
            childList: true,
        });
    }
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    componentDidUpdate() {
        this.handleSlottedContent();
    }
    disconnectedCallback() {
        var _a, _b;
        (_a = this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.el.firstElementChild) === null || _b === void 0 ? void 0 : _b.removeEventListener("click", this.handleClick);
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '2fd6a14278f8ce597a945e1d1ea216616ea05ceb', class: {
                "tds-sidenav-item": true,
                selected: this.selected,
            }, role: "listitem" }, h("slot", { key: '0b1aae7b72448aaf718500cf655dc7a772efa72c' }), h("slot", { key: 'b6a65573d62b6dbb1ea5eb86da8305153b7c91e3', name: "subnav" })));
    }
    get el() { return this; }
}, [6, "tds-sidenav-item", {
        "selected": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-item"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SidenavItem);
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav-item.js.map
